<div class="sidebar">
  <!-- <app-sidebar-header></app-sidebar-header> -->
  <app-sidebar-form></app-sidebar-form>
  <app-sidebar-nav></app-sidebar-nav>
  <app-sidebar-footer></app-sidebar-footer>
  <!-- <app-sidebar-minimizer></app-sidebar-minimizer> -->
</div>


// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/components/app-sidebar/app-sidebar.component.html